import React from 'react';
import { Box, Typography } from '@mui/material';
import { XCircle } from '../../svg/XCircle';
import { useAppDispatch } from '../../../app/hooks';
import { initializeState } from '../../../app/thunks/init-state';
import { useAppTranslation } from '../../../i18n';
import StepButton from '../StepButton';

const TRANSLATION_PREFIX = 'steps.pos-ident-error';

const PosIdentError = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();

	const handleBackToStart = () => {
		dispatch(initializeState());
	};

	return (
		<Box id="pos-ident-error-step" sx={{ textAlign: 'center' }}>
			<Box sx={textContainerSX}>
				<Typography sx={{ ...textSX, fontSize: 'large', fontWeight: 600 }}>
					{t(`${TRANSLATION_PREFIX}.title`)}
				</Typography>
			</Box>

			<Box id="icon-container" sx={iconBoxSX}>
				<XCircle />
			</Box>

			<Box sx={textContainerSX}>
				<Typography sx={textSX}>{t(`${TRANSLATION_PREFIX}.description`)}</Typography>
			</Box>

			<StepButton disabled={false} title={t(`${TRANSLATION_PREFIX}.back-to-start`)} onClick={handleBackToStart} />
		</Box>
	);
};

const iconBoxSX = {
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	padding: '5%',
	'& svg': {
		width: '40%'
	}
};

const textContainerSX = {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: 1
};

const textSX = {
	textAlign: 'center'
};

export default PosIdentError;
